exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (min-width:64em){.app main{width:calc(75% - 1rem);margin-right:1rem}.app aside{flex:25% 0 0;display:block}div.app.large{max-width:1290px;margin:2rem auto;padding:1.5rem;background:#fff}.mkdf-content-inner{background:#eee}aside.sidebar>*{margin:0;margin-bottom:1rem}}@media screen and (min-width:1290px){div.app.large{border-radius:1rem;overflow:hidden;box-shadow:0 0 10px 1px rgba(0,0,0,.17)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/article/large-up.css
// module id = 58
// module chunks = 4